import React, { useState, useEffect } from "react";
import ScheduleList from "../components/Schedule";
import "../styles/schedule.css";
import "./Demo.css";

const dummySchedule = [
    {
      id: "1",
      eventName: "Gates Open",
      location: "Main Entrance",
      description: "Festival gates officially open to the public.",
      startDate: "2025-06-01",
      startTime: "10:00",
      endTime: "10:30",
    },
    {
      id: "2",
      eventName: "Local Band Showcase",
      location: "Green Stage",
      description: "Up-and-coming local bands perform their latest sets.",
      startDate: "2025-06-01",
      startTime: "12:00",
      endTime: "13:30",
    },
    {
      id: "3",
      eventName: "Main Headliner: The Overtones",
      location: "Green Stage",
      description: "The Overtones perform their greatest hits.",
      startDate: "2025-06-02",
      startTime: "18:00",
      endTime: "20:00",
    },
    {
      id: "4",
      eventName: "Electronica After Party",
      location: "Second Stage",
      description: "Late-night DJ set and visual experience for dance lovers.",
      startDate: "2025-06-02",
      startTime: "22:00",
      endTime: "23:30",
    },
    {
      id: "5",
      eventName: "Closing Fireworks",
      location: "Green Stage",
      description: "Celebrate the end of the festival with a fireworks finale.",
      startDate: "2025-06-03",
      startTime: "21:00",
      endTime: "21:30",
    },
  ];
  

const Demo = () => {
  const [phoneView, setPhoneView] = useState(false);
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  // Determine if the user is already on a small screen (e.g. phone)
  useEffect(() => {
    function checkScreenSize() {
      setIsSmallScreen(window.innerWidth <= 600);
    }

    // Initial check
    checkScreenSize();

    // Listen for resizing
    window.addEventListener("resize", checkScreenSize);
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  // If on a small screen, force phoneView = true and hide the toggle
  useEffect(() => {
    if (isSmallScreen) {
      setPhoneView(true);
    }
  }, [isSmallScreen]);

  return (
    <div className="demo-container">
      <h2 style={{ margin: "20px", paddingTop: "30px" }}>Event Schedule Demo</h2>

      {/* Hide the toggle if already on a phone */}
      {!isSmallScreen && (
        <div style={{ marginLeft: "30px" }}>
          <label className="checkbox-container">
            <input
              type="checkbox"
              checked={phoneView}
              onChange={() => setPhoneView(!phoneView)}
            />
            View on phone dimensions
          </label>
        </div>
      )}

      {/* Pass phoneView to the ScheduleList */}
      <ScheduleList schedule={dummySchedule} phoneView={phoneView} />
    </div>
  );
};

export default Demo;
